import { toast } from '@heidi/design-system/toast';
import { useTranslations } from '@heidi/runtime/i18n';
import { useMutateDeleteEmptySessions as useMutateDeleteEmptySessionsCore } from '@heidi/session/data';

export function useMutateDeleteEmptySessions() {
  const { t } = useTranslations();

  return useMutateDeleteEmptySessionsCore({
    onEmptySessionsDeleted: (numDeleted) => {
      if (numDeleted > 0) {
        toast({
          tone: 'success',
          title:
            numDeleted === 1
              ? t('session.emptySessionDeleted', { count: numDeleted })
              : t('session.emptySessionsDeleted', { count: numDeleted }),
        });
      } else {
        toast({
          tone: 'default',
          title: t('session.noEmptySessionsToDelete'),
        });
      }
    },
  });
}
